import "./Header.css";
import logo from "../../assets/elevatespacelogo.png";
import { useState, useEffect } from "react";

const Header = () => {
  const [showBg, setShowBg] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowBg(window.scrollY > 120); // 👈 adjust scroll trigger here
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header className="hero" id="home">
      {/* Navbar */}
      <nav className={`navbar ${showBg ? "navbar-bg" : ""}`}>
        <div className="logo">
          <img className="logo-img" src={logo} alt="Elevate Space" />
          {/* <span className="logo-text">Elevate Space</span> */}
        </div>
        <ul className="nav-links">
          <li><a href="#home">Home</a></li>
          <li><a href="#about">About</a></li>
          <li><a href="#services">Services</a></li>
          <li><a href="#contact">Contact</a></li>
          {/* <li>Projects</li> */}
        </ul>
      </nav>

      {/* Hero Content */}
      <div className="hero-content">
        <h1 className="web-title">Elevate Your Space</h1>
        <h1>Designing Spaces That Tell Your Story</h1>
        <p>Elegant. Functional. Timeless interiors crafted just for you.</p>
        <button>Explore Designs</button>
      </div>
    </header>
  );
}

export { Header };